<script>
  import { layoutMethods, maintenanceMethods } from "@/state/helpers"; //getModuleAccess
  import { getModuleAccess, showAccessRestrictedModal } from '@/router/helper.js'
  import Swal from "sweetalert2";
  import flatPickr from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";
  import moment from 'moment-timezone';

  export default {
    data() {
      return {
        title: "Maintenance Mode",
        modulesData: [],
        typeModules: { // Just add another type of modules here based on database module_name from ref_modules
          kankolek: "kankolek Transaction"
        },
        currentModule: '',
        maintenanceReasonOption: [
           'Maintenance',
           'Bug/Issue',
           'Change in Business Strategy',
           'Fraud Investigation',
           'Change in Fee Structure',
        ],

        maintenanceDoneReasonOption: [
          'Completed Maintenance',
          'Resolved Bug/Issue',
          'Resolved Fraud Investigation'
        ],
        filterStatusOptions: [
          {text: 'All', value: ''},
          {text: 'Active', value: 'active'},
          {text: 'Inactive', value: 'inactive'}
        ],
        maxTitleInput: 35,
        maxContentInput: 102,

        logsCurrentPage: 1,
        logsPerPage: 10,
        logsPageOptions: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
        logsSort: 'id',
        logsSortBy: "value",
        logsSortDesc: false,
        logsDateRange: null,
        logsOrderDesc: true,
        startDate: moment().tz('Asia/Manila').format('YYYY-MM-DD'),
        startDateTime: moment().tz('Asia/Manila').startOf('minute').add(5 - moment().tz('Asia/Manila').minute() % 5, 'minutes').format('HH:mm'),
        endDate:  moment().tz('Asia/Manila').format('YYYY-MM-DD'),
        endDateTime:moment().tz('Asia/Manila').startOf('minute').add(5 - moment().tz('Asia/Manila').minute() % 5, 'minutes').format('HH:mm'),
        startDateConfig: {
            mode: "single",
            minDate: moment().tz('Asia/Manila').format('YYYY-MM-DD'),
            // dateFormat: "Y-n-j",
        },
        startDateTimeConfig: {
          defaultDate: moment().tz('Asia/Manila').startOf('minute').add(5 - moment().tz('Asia/Manila').minute() % 5, 'minutes').format('HH:mm'),
          enableTime: true,
          noCalendar: true,
          dateFormat: "H:i:00",
          altInput: true,
          altFormat: "G:i K",
        },
        endDateConfig: {
            mode: "single",
            minDate: moment().tz('Asia/Manila').format('YYYY-MM-DD'),
            // dateFormat: "Y-n-j"
        },
        endDateTimeConfig: {
          defaultDate: moment().tz('Asia/Manila').startOf('minute').add(5 - moment().tz('Asia/Manila').minute() % 5, 'minutes').format('HH:mm'),
          enableTime: true,
          noCalendar: true,
          dateFormat: "H:i:00",
          altInput: true,
          altFormat: "G:i K",
          minTime: moment().tz('Asia/Manila').startOf('minute').add(5 - moment().tz('Asia/Manila').minute() % 5, 'minutes').format('HH:mm'),
        },


        rangeOptions: {
          mode: "range",
        },

        logsFilterStatus: '',
        
        showMaintenanceLogs: false,
        maintenanceLogsTotal: 0,
        maintenanceLogs: [],
        maintenanceLogFields: [
          {
            key: "status",
            label: "Status",
            sortable: false,
            tdClass: 'align-middle',
            thStyle: ''
          },
          {
            key: "remarks",
            label: "Activity",
            sortable: false,
            tdClass: 'align-middle',
            thStyle: ''
          },
          {
            key: "reason",
            label: "Reason",
            sortable: false,
            tdClass: 'align-middle',
          },
          {
            key: "created_at",
            label: "Date Created",
            sortable: true,
            tdClass: 'align-middle',
          },
          {
            key: "actor",
            label: "Modified By",
            sortable: false,
            tdClass: 'align-middle',
          },
        ],
        maintenanceModeModule: {
          access: {
            read: false,
            update: false
          }
        },
        
      };
    },
    components: { 
      flatPickr
    },
    computed: {
      // ...maintenanceComputed,
    },
    
    methods: {
      ...layoutMethods,
      ...maintenanceMethods,

      async getMaintenanceLogsData(module) {
          this.logsCurrentPage = this.isSearching ? 1 : this.logsCurrentPage;
          this.currentModule = module;
          
          let params = {
            
              module: 'MAINTENANCE_MODE',
              subModule: module,
              sort: 'DESC',
              page: this.logsCurrentPage,
              rows: this.logsPerPage,
              orderDesc: this.logsOrderDesc,
              dateRange: this.logsDateRange,
              status: this.logsFilterStatus
            
          }

          await this.getMaintenanceModeLogs(params)
            .then((data) => {
              console.log("this.maintenanceLogsList: ", this.maintenanceLogsTotal);
              this.maintenanceLogsTotal = data.message.pageInfo.total;
              this.maintenanceLogs = JSON.parse(JSON.stringify(data.message.rows));
              this.maintenanceLogs = this.maintenanceLogs.map(log => {
                log.details = {action: log.action,...JSON.parse(log.details)};
                return log;
              })
              this.showMaintenanceLogs = true;
          })
      },
      closeLogsModal() {
        this.showMaintenanceLogs = false;
        this.logsDateRange = null;
        // this.filter.status = null;
        this.logsCurrentPage = 1;
        this.logsPerPage = 10;
        this.logsSort = 'id';
        this.logsSortBy = 'value';
        this.logsSortDesc = false;
        this.logsOrderDesc = true;
      },
      tableSorting(action) {
        var column = "";
        switch(action.sortBy) {
            case 'rate' :
                column = 'rate';
                break;
            case 'startDate' :
                column = 'startDate';
                break;
            case 'endDate' :
                column = 'endDate';
                break;
            case 'dateCreated' :
                column = 'createdAt';
                break;
            case 'createdBy' :
                column = 'actor';
                break;
        }
        this.logsSort = column;
        this.logsOrderDesc = action.sortDesc;
        this.getMaintenanceLogsData(this.currentModule);
      },
      getTimeDifference() {
        if (this.startDate && this.startDateTime && this.endDate && this.endDateTime) {
          const startDateTime = moment(`${this.startDate} ${this.startDateTime}`).tz('Asia/Manila');
          const endDateTime = moment(`${this.endDate} ${this.endDateTime}`).tz('Asia/Manila');

          const duration = moment.duration(endDateTime.diff(startDateTime));

          const days = duration.days();
          const hours = duration.hours();
          const minutes = duration.minutes();

          let result = '';

          if (days > 0) {
            result = `${days}d `;
          }

          if (hours > 0) {
            result = result ? `${result}${hours}h ` : `${hours}h `;
          }

          if (minutes > 0) {
            result = result ? `${result}${minutes}m` : `${minutes}m`;
          }

          return result != '' ? `${result.trim()}` : '0m';
        }
        return '';
      },


      getCleanedLength(str) {
        return str.replace(/\{.*?\}/g, '').length;
      },


      getStatusTextColorClass(status) {
        return status === 1 ? 'status-color-active' : 'status-color-inactive';
      },
      endHtml(module) {
        console.log("endHtml status", module.status);
        var statustxt = 'activate';
        var reasons = [];
        if (module.status == 0) {
          reasons = this.maintenanceDoneReasonOption;
        } else if (module.status == 1) {
          reasons = this.maintenanceReasonOption;
          statustxt = 'deactivate';
        }

        var titleDiv = `<div class="mb-4" style="font-weight: 450;">Are you sure you want to ${statustxt} the <span style="color: #eb499f;">${this.typeModules[module.module_name]}</span>?</div>`;

        var selectOne = '<select id="maintenance-remarks" class="form-control">'
        selectOne += '<option value="" disabled selected>Select reason</option>'
        reasons.forEach(r => {
          selectOne += `<option value="${r}">${r}</option>`
        });
        selectOne += "</select>";
        var divOne = '<div class="mb-4">' + selectOne + '</div>';

        
        var inputOne = `
          <input
            type="text"
            id="maintenance-title"
            class="form-control"
            placeholder="Title"   
            value="${module.title}" 
          >
        `;

        var divTwo = `
        <div class="mb-4 ">
          <div class="d-flex align-items-start">
              ${inputOne}
              
            </div>
            <div class="position-absolute" style="font-family: Roboto; font-size: 12px; font-weight: 500; line-height: 14px; letter-spacing: 0.03em; color: grey;">
              ${module.title.length > this.maxTitleInput ? `<span id="titleCountSpan" style="color: red;">${module.title.length}/${this.maxTitleInput} characters</span>` : `<span id="titleCountSpan">${module.title.length}/${this.maxTitleInput} characters</span>`}
            </div>
          </div>
        `;

        var inputTwo = `
          <textarea
            id="maintenance-content"
            class="form-control"
            placeholder="Type here the description..."    
            style="height: 124px;"
            
          >${module.content}</textarea>
        `;

        var divThree = `
        <div class="mb-4">
          <div class="d-flex align-items-start">
              ${inputTwo}
              
            </div>
            <div class="position-absolute" style="font-family: Roboto; font-size: 12px; font-weight: 500; line-height: 14px; letter-spacing: 0.03em; color: grey;">
              ${this.getCleanedLength(module.content) > this.maxContentInput ? `<span id="contentCountSpan" style="color: red;">${this.getCleanedLength(module.content)}/${this.maxContentInput} characters</span>` : `<span id="contentCountSpan">${this.getCleanedLength(module.content)}/${this.maxContentInput} characters</span>`}
            </div>
          </div>
        `;


        var html = module.status == 1 ? `<div>${titleDiv}${divOne}${divTwo}${divThree}</div>` : `<div>${titleDiv}${divOne}</div>`;
        return {
          html: html,
          preConfirm: function () {
            
            if (!document.getElementById('maintenance-remarks').value) {
              return Swal.showValidationMessage("Please select a reason");
            }
            
            if (module.status != 1) {
              var titleInputValue = document.getElementById('maintenance-title').value;
              var contentInputValue = document.getElementById('maintenance-content').value;


              var titleInputLength = titleInputValue.length;
              var contentInputLength = this.getCleanedLength(contentInputValue);

              if (!titleInputValue.trim()) {
                  return Swal.showValidationMessage("Title must not be empty!");
              } 
              if (!contentInputValue.trim()) {
                  return Swal.showValidationMessage("Description must not be empty!");
              } 
              if (titleInputLength > this.maxTitleInput) {
                  return Swal.showValidationMessage(`Title characters limit exceeded (${this.maxTitleInput} characters max)`);
              }
              if (contentInputLength > this.maxContentInput) {
                  return Swal.showValidationMessage(`Description characters limit exceeded (${this.maxContentInput} characters max)`);
              }
            }

            
          }.bind(this),
        };
      },

      schedMaintenanceHTML(module) {
        console.log("schedMaintenanceHTML status", module.status);
        // var statustxt = 'activate';
        var reasons = [];
        // if (module.status == 0) {
        //   reasons = this.maintenanceDoneReasonOption;
        // } else if (module.status == 1) {
        //   reasons = this.maintenanceReasonOption;
        //   // statustxt = 'deactivate';
        // }
        reasons = this.maintenanceReasonOption;

        var titleDiv = `<div class="mb-4" style="font-weight: 450;">Are you sure you want to deactivate Schedule Maintenance the <span style="color: #eb499f;">${this.typeModules[module.module_name]}</span> for ${this.getTimeDifference()}?</div>`;

        var selectOne = '<select id="maintenance-remarks" class="form-control">'
        selectOne += '<option value="" disabled selected>Select reason</option>'
        reasons.forEach(r => {
          selectOne += `<option value="${r}">${r}</option>`
        });
        selectOne += "</select>";
        var divOne = '<div class="mb-4">' + selectOne + '</div>';

        
        var inputOne = `
          <input
            type="text"
            id="maintenance-title"
            class="form-control"
            placeholder="Title"   
            value="${module.title}" 
          >
        `;

        var divTwo = `
        <div class="mb-4 ">
          <div class="d-flex align-items-start">
              ${inputOne}
              
            </div>
            <div class="position-absolute" style="font-family: Roboto; font-size: 12px; font-weight: 500; line-height: 14px; letter-spacing: 0.03em; color: grey;">
              ${module.title.length > this.maxTitleInput ? `<span id="titleCountSpan" style="color: red;">${module.title.length}/${this.maxTitleInput} characters</span>` : `<span id="titleCountSpan">${module.title.length}/${this.maxTitleInput} characters</span>`}
            </div>
          </div>
        `;

        var inputTwo = `
          <textarea
            id="maintenance-content"
            class="form-control"
            placeholder="Type here the description..."    
            style="height: 124px;"
            
          >${module.content}</textarea>
        `;

        var divThree = `
        <div class="mb-4">
          <div class="d-flex align-items-start">
              ${inputTwo}
              
            </div>
            <div class="position-absolute" style="font-family: Roboto; font-size: 12px; font-weight: 500; line-height: 14px; letter-spacing: 0.03em; color: grey;">
              ${this.getCleanedLength(module.content) > this.maxContentInput ? `<span id="contentCountSpan" style="color: red;">${this.getCleanedLength(module.content)}/${this.maxContentInput} characters</span>` : `<span id="contentCountSpan">${this.getCleanedLength(module.content)}/${this.maxContentInput} characters</span>`}
            </div>
          </div>
        `;


        var html =  `<div>${titleDiv}${divOne}${divTwo}${divThree}</div>`;
        return {
          html: html,
          preConfirm: function () {
            
            if (!document.getElementById('maintenance-remarks').value) {
              return Swal.showValidationMessage("Please select a reason");
            }
            
            
            var titleInputValue = document.getElementById('maintenance-title').value;
            var contentInputValue = document.getElementById('maintenance-content').value;


            var titleInputLength = titleInputValue.length;
            var contentInputLength = this.getCleanedLength(contentInputValue);

            if (!titleInputValue.trim()) {
                return Swal.showValidationMessage("Title must not be empty!");
            } 
            if (!contentInputValue.trim()) {
                return Swal.showValidationMessage("Description must not be empty!");
            } 
            if (titleInputLength > this.maxTitleInput) {
                return Swal.showValidationMessage(`Title characters limit exceeded (${this.maxTitleInput} characters max)`);
            }
            if (contentInputLength > this.maxContentInput) {
                return Swal.showValidationMessage(`Description characters limit exceeded (${this.maxContentInput} characters max)`);
            }
          

            
          }.bind(this),
        };
      },

      scheduleMaintenance: function (md) {

        if(this.getTimeDifference() == '0m')
        {
          Swal.fire({
              title: "Warning",
              html: `Start Date & Time -> End Date & Time must be setted correctly!`,
              icon: "error"
          });
          return;
        }

        if(md.maintenance_option != null || md.maintenance_option != "" || md.maintenance_option != "null")
        {
          // eslint-disable-next-line no-unused-vars
          // let {startDate, endDate} = JSON.parse(md.maintenance_option);
          console.log("this.startDate", this.startDate + ' ' + this.startDateTime);
          // console.log("endDate", endDate);

          if(moment().tz('Asia/Manila').isAfter(moment(this.startDate + ' ' + this.startDateTime).tz('Asia/Manila')))
          {
            Swal.fire({
                title: "Warning",
                html: `Start Date & Time of Schedule Maintenance is outdated with the current date.`,
                icon: "error"
            });
            return;
          }

          // if(moment(this.endDate + ' ' + this.endDateTime).tz('Asia/Manila').isSame(moment(endDate).tz('Asia/Manila')))
          // {
          //   Swal.fire({
          //       title: "Warning",
          //       html: `End date must not be the same in the database!`,
          //       icon: "error"
          //   });
          //   return;
          // }
        }
        //   this.startDate = moment(startDate).tz('Asia/Manila').format("YYYY-DD-MM");
        //   this.startDateTime = moment(startDate).tz('Asia/Manila').format("HH:mm");

        //   this.endDate = moment(endDate).tz('Asia/Manila').format("YYYY-DD-MM");
        //   this.endDateeTime = moment(endDate).tz('Asia/Manila').format("HH:mm");
        // }

        var { html, preConfirm } = this.schedMaintenanceHTML(md);
        Swal.fire({
          title: this.typeModules[md.module_name],
          html: html,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#804997',
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          customClass: {
            confirmButton: 'px-5',
            cancelButton: 'px-5'
          },
          didOpen: () => {  
            
              var maintenanceTitleInput = document.getElementById('maintenance-title');
              var titleCountSpan = document.getElementById('titleCountSpan');

              maintenanceTitleInput.addEventListener('input', function () {
                  var inputValue = maintenanceTitleInput.value;

                  // var cleanedInput = inputValue.replace(/\{.*?\}/g, '');

                  var inputLength = inputValue.length;

                  if (titleCountSpan) {
                      titleCountSpan.textContent = `${inputLength}/${this.maxTitleInput} characters`;

                      if (inputLength > this.maxTitleInput) {
                          titleCountSpan.style.color = 'red'; 
                      } else {
                          titleCountSpan.style.color = ''; 
                      }
                  }
              }.bind(this));

              var maintenanceContentInput = document.getElementById('maintenance-content');
              var contentCountSpan = document.getElementById('contentCountSpan');

              maintenanceContentInput.addEventListener('input', function () {
                  var inputValue = maintenanceContentInput.value;
                  var inputLength = this.getCleanedLength(inputValue);

                  if (contentCountSpan) {
                      contentCountSpan.textContent = `${inputLength}/${this.maxContentInput} characters`;

                      if (inputLength > this.maxContentInput) {
                          contentCountSpan.style.color = 'red'; 
                      } else {
                          contentCountSpan.style.color = ''; 
                      }
                  }
              }.bind(this));
        },

          preConfirm: preConfirm
        }).then((result) => {
          if (result.isConfirmed) {
            //Perform the update based on user confirmation

            if (!this.maintenanceModeModule.access.update) {
              showAccessRestrictedModal();
              return;
            }
            
            // md.maintenance_option = `${}`;
            this.updateSchedMaintenanceModeData({
              module: md.module_name,
              title: document.getElementById('maintenance-title').value,
              content: document.getElementById('maintenance-content').value,
              startDate: `${this.startDate} ${this.startDateTime}`,
              endDate: `${this.endDate} ${this.endDateTime}`,
              reason: document.getElementById('maintenance-remarks').value
            }).then(async() => {
              Swal.fire({
                  title:"Update Successful!",
                  html: `<span style="color: #eb499f;">${this.typeModules[md.module_name]}</span> has been schedule maintenance from ${this.startDate + ' ' + this.startDateTime} → ${this.endDate + ' ' + this.endDateTime} (${this.getTimeDifference()}).`,
                  icon: "success"
              });
              await this.fetchMaintenanceData();
            }).catch(err => {
              Swal.fire({
                  title: "Update Failed!",
                  html: `<span style="color: #eb499f;">${this.typeModules[md.module_name]}</span> was not updated.`,
                  icon: "error"
              });
              console.log("err: ", err);
            });
          } else {
            // Do nothing
          }
        });
      },

      endScheduleMaintenance: function (md) {
        Swal.fire({
          title: "Maintenance",
          html: "Are you sure you want to end scheduled maintenance?",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#804997',
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          customClass: {
            confirmButton: 'px-5',
            cancelButton: 'px-5'
          }
        }).then((result) => {
          if(result.isConfirmed){
            this.endScheduledMaintenance({
              module: md.module_name,
            }).then(async() => {
              Swal.fire({
                  title:"Update Successful!",
                  html: `<span style="color: #eb499f;">You’ve successfully ended the Maintenance Schedule</span>`,
                  icon: "success"
              });
              await this.fetchMaintenanceData();
            }).catch(err => {
              Swal.fire({
                  title: "Update Failed!",
                  html: `<span style="color: #eb499f;">${this.typeModules[md.module_name]}</span> was not updated.`,
                  icon: "error"
              });
              console.log("err: ", err);
            });
          }
        });
      },
      parseDateTime12H(data, type = "")
      {
        let parseJson = (data.maintenance_option != null && data.maintenance_option != "" && data.maintenance_option != "null")  ? JSON.parse(data.maintenance_option) : null;
        if(parseJson != null && parseJson != "" && parseJson != "null")
        {
          let {startDate, endDate} = parseJson;
          if(type == 'startdate')
          {
            return moment(startDate).tz('Asia/Manila').format("YYYY-MM-DD hh:mm A");
          }
          else if(type == 'enddate')
          {
            return moment(endDate).tz('Asia/Manila').format("YYYY-MM-DD hh:mm A");
          }
        }
        return '';
      },

      toggleStatus: function (md) {
        // console.log("toggleStatus: ", JSON.stringify(md));

        var oldStatus = md.status; // Store the current status
        
        

        var { html, preConfirm } = this.endHtml(md);

        Swal.fire({
          title: this.typeModules[md.module_name],
          html: html,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#804997',
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          customClass: {
            confirmButton: 'px-5',
            cancelButton: 'px-5'
          },
          didOpen: () => {  
            if (md.status !== 1) {
                var maintenanceTitleInput = document.getElementById('maintenance-title');
                var titleCountSpan = document.getElementById('titleCountSpan');

                maintenanceTitleInput.addEventListener('input', function () {
                    var inputValue = maintenanceTitleInput.value;

                    // var cleanedInput = inputValue.replace(/\{.*?\}/g, '');

                    var inputLength = inputValue.length;

                    if (titleCountSpan) {
                        titleCountSpan.textContent = `${inputLength}/${this.maxTitleInput} characters`;

                        if (inputLength > this.maxTitleInput) {
                            titleCountSpan.style.color = 'red'; 
                        } else {
                            titleCountSpan.style.color = ''; 
                        }
                    }
                }.bind(this));

                var maintenanceContentInput = document.getElementById('maintenance-content');
                var contentCountSpan = document.getElementById('contentCountSpan');

                maintenanceContentInput.addEventListener('input', function () {
                    var inputValue = maintenanceContentInput.value;
                    var inputLength = this.getCleanedLength(inputValue);

                    if (contentCountSpan) {
                        contentCountSpan.textContent = `${inputLength}/${this.maxContentInput} characters`;

                        if (inputLength > this.maxContentInput) {
                            contentCountSpan.style.color = 'red'; 
                        } else {
                            contentCountSpan.style.color = ''; 
                        }
                    }
                }.bind(this));
            }
        },

          preConfirm: preConfirm
        }).then((result) => {
          if (result.isConfirmed) {
            //Perform the update based on user confirmation

            if (!this.maintenanceModeModule.access.update) {
              md.status = oldStatus;
              showAccessRestrictedModal();
              return;
            }
            
            this.updateMaintenanceModeData({
              module: md.module_name,
              title: md.status == 0 ? document.getElementById('maintenance-title').value : md.title,
              content: md.status == 0 ? document.getElementById('maintenance-content').value : md.content,
              status: parseInt(md.status),
              reason: document.getElementById('maintenance-remarks').value
            }).then(async() => {
              Swal.fire({
                  title:"Update Successful!",
                  html: `<span style="color: #eb499f;">${this.typeModules[md.module_name]}</span> has been updated and is now ${!oldStatus ? 'activated' : "deactivated"}.`,
                  icon: "success"
              });
              await this.fetchMaintenanceData();
            }).catch(err => {
              // If the update fails, revert to the old status
              md.status = oldStatus;
              Swal.fire({
                  title: "Update Failed!",
                  html: `<span style="color: #eb499f;">${this.typeModules[md.module_name]}</span> was not updated.`,
                  icon: "error"
              });
              console.log("err: ", err);
            });
          } else {
            // If the user clicks "No", revert to the old status
            md.status = oldStatus;
          }
        });
      },


      async fetchMaintenanceData() {
        // for now fetch kankolek
        let data = await this.getMaintenanceModeData({search: 'kankolek'});
        let isForce = false
        if (data.status === 'ok') {
          // Make a copy of the data from Vuex
          this.modulesData = [...data.message.rows];

          // Parse maintenance_option 
          for(let obj of this.modulesData)
          {
            if(obj.maintenance_option != null && obj.maintenance_option != "" && obj.maintenance_option != "null")
            {
              let {startDate, endDate} = JSON.parse(obj.maintenance_option);
              let endDateTimex = moment(endDate).tz('Asia/Manila').format("YYYY-MM-DD HH:mm");
              this.startDate = moment(startDate).tz('Asia/Manila').format("YYYY-MM-DD");
              this.startDateTime = moment(startDate).tz('Asia/Manila').format("HH:mm");
              this.endDate = moment(endDate).tz('Asia/Manila').format("YYYY-MM-DD");
              this.endDateTime = moment(endDate).tz('Asia/Manila').format("HH:mm");
              if(moment().tz('Asia/Manila').format("YYYY-MM-DD HH:mm") < endDateTimex){
                isForce = true
              }
            }
          }
        }
        this.modulesData[0].isForce = isForce
        console.log('modulesData',this.modulesData);
        
        // this.modulesData = this.modules;
      },
      // async updateMaintenanceData(params) {
      //   await this.updateMaintenanceModeData(params).then(response => {

      //   })
      //   .catch(error => {

      //   })
      // }
     
    },
    watch: {
      startDateTime(newVal) {
//        console.log("newVal:", moment(moment().tz('Asia/Manila').format("YYYY-MM-DD") + ' ' + newVal).tz('Asia/Manila').format("hh:mm"));
        this.endDateTimeConfig.minTime = newVal;

      },
    },
    async mounted(){
      this.changeTitle({title: this.title});
      this.changeBreadCrumb({
        breadCrumbs: [
          { text: 'Peddlr', to: { name: 'Home'} },
          { text: 'Maintenance', to: { name: 'Maintenance Mode'} }
        ]
      });

      // console.log(moment().tz('Asia/Manila').format('YYYY-MM-DD'));

      // get the module access for checking if user has create, read, update, and/or delete access
      await getModuleAccess('Settings', 'Maintenance Mode').then((access) => this.maintenanceModeModule.access = access);

      // Fetch the Maintenance Data
      await this.fetchMaintenanceData();
      
    }
  }
    
</script>

<template>
  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <div class="row" v-for="(data, index) in modulesData" :key="index">
            <b-tabs content-class="p-3 text-muted" nav-class="nav-tabs-custom">
              <b-tab>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-home"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">{{data.module_name}}</span>
                </template>
              </b-tab>
            </b-tabs>
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <h3>{{typeModules[data.module_name]}}</h3>
                <span>This is the whole process of {{data.module_name}}</span>
              </div>
              <div class="d-flex align-items-center mx-0">
                <label class="form-check-label form-label mx-3">
                  <span>Status: </span>
                  <span :class="getStatusTextColorClass(data.status)">
                    {{ data.status === 1 ? 'Active' : 'Inactive' }}
                  </span>
                </label>
                <div class="form-check form-switch form-switch-md">
                  <input type="checkbox" class="form-check-input" v-model="data.status" true-value="1" false-value="0" @click="toggleStatus(data)" />
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-end mt-3">
              <div class="d-flex align-items-center">
                <flat-pickr v-model="startDate" :config="startDateConfig" class="form-control mx-2" style="width:110px;"></flat-pickr>
                <flat-pickr v-model="startDateTime" :config="startDateTimeConfig" class="form-control"></flat-pickr>
                <span class="mx-2">→</span> <!-- Right arrow icon -->
                <flat-pickr v-model="endDate" :config="endDateConfig" class="form-control mx-2" style="width:110px;"></flat-pickr>
                <flat-pickr v-model="endDateTime" :config="endDateTimeConfig" class="form-control mx-2"></flat-pickr>
                <span class="mx-2 p-2" style="white-space: nowrap;">({{ getTimeDifference() }})</span>
                <b-button class="w-sm me-2" @click="scheduleMaintenance(data)">Schedule</b-button>
                <b-button class="w-sm " @click="endScheduleMaintenance(data)" v-if="data.isForce">Force End</b-button>
              </div>
            </div>

            <div  v-if="parseDateTime12H(data, 'startdate') != ''" class="d-flex justify-content-end">
              <div class="d-flex align-items-center text-muted">
                <span class="small">Schedule Maintenance: <strong>{{ parseDateTime12H(data, 'startdate') }}</strong> → <strong>{{ parseDateTime12H(data, 'enddate') }}</strong></span>
              </div>
            </div>
            

            <hr class="hr-custom mb-3 mt-4" />
            <div class="col-md-12 mt-3">
              <label class="form-label fw-bold my-2">Activity Logs: &nbsp;</label>
              <label class="form-label fw-bold my-2">
                <b-link @click="getMaintenanceLogsData(data.module_name)">View</b-link>
              </label>
            </div>
            <!-- end col -->
            <!-- Maintenance Logs -->
            <b-modal v-model="showMaintenanceLogs" size="xl" centered hide-header hide-footer hide-header-close no-close-on-backdrop>
              <form class="px-4 py-3">
                <div class="row">
                  <div class="col-lg-12">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-md-6">
                          <div class="mb-3">
                            <h5 class="card-title">
                              Activity Logs: {{data.module_name}}
                            </h5>
                          </div>
                        </div>
                        <!-- Date Range -->
                        <div class="col-md-12">
                          <div class="d-flex flex-wrap mt-3 mb-2 ta-right gap-2">
                            <div class="col-sm-3" style="width: fit-content;">
                              <b-form-group description="Filter by date">
                                <flat-pickr v-model="logsDateRange" :config="rangeOptions" placeholder="Select a date range" class="form-control" style="width: 250px;"></flat-pickr>
                              </b-form-group>
                            </div>
                            <div class="col-sm-2">
                              <b-form-group label-for="status" description="Filter by status">
                                <b-form-select class="form-select rounded-0 rounded-start rounded-end shadow-none" v-model="logsFilterStatus" :options="filterStatusOptions"></b-form-select>
                              </b-form-group>
                            </div>
                            <div class="col-sm-1" style="width: fit-content;">
                              <b-button variant="primary" type="button" @click="isSearching =true; getMaintenanceLogsData(currentModule)" class="px-2 d-flex align-items-center">
                                <div><i class="bx bx-search bx-fw"></i></div>
                                <div>Search</div>
                              </b-button>
                            </div>
                            <!-- <div class="col-sm-1" style="width: fit-content">
                                             <b-button variant="primary" @click="onExport" type="button" class="px-2 d-flex align-items-center">
                                               <div><i class='uil uil-export me-1'></i></div>
                                               <div>Export</div>
                                             </b-button>
                                             </div> -->
                          </div>
                        </div>
                      </div>
                      <div class="table-responsive">
                        <div class="table align-middle table-nowrap">
                          <b-table
                            :items="maintenanceLogs"
                            :fields="maintenanceLogFields"
                            responsive="sm"
                            :current-page="logsCurrentPage"
                            :sort-by.sync="logsSortBy"
                            :sort-desc.sync="logsSortDesc"
                            class="table-check"
                            @sort-changed="tableSorting"
                          >
                            <template #cell(status)="data">
                              <p class="text-body m-0">
                                {{ data.item.details.status }}
                              </p>
                            </template>
                            <template #cell(remarks)="data">
                              <p class="text-body m-0">
                                {{ data.item.remarks }}
                              </p>
                            </template>
                            <template #cell(reason)="data">
                              <p class="text-body m-0">
                                {{ data.item.details.reason }}
                              </p>
                            </template>
                            <template #cell(created_at)="data">
                              <p class="text-body m-0">
                                {{ data.item.created_at | customFormatDate}}
                              </p>
                            </template>
                            <template #cell(actor)="data">
                              <p class="text-body m-0">
                                {{ data.item.actor }}
                              </p>
                            </template>
                          </b-table>
                        </div>
                      </div>
                      <!-- end table responsive -->
                      <div class="row g-0 text-center" v-if="maintenanceLogsTotal == 0">
                        <span>No data to display.</span>
                      </div>
                      <div class="row g-0 text-center text-sm-start" v-if="maintenanceLogsTotal != 0 && maintenanceLogsTotal > 10">
                        <!-- end col -->
                        <div class="col-sm-12">
                          <div class="row">
                            <div class="col">
                              <div class="form-group row pull-left">
                                <label for="staticEmail" class="col-sm-6 col-form-label">Display:</label>
                                <div class="col-sm-6">
                                  <b-form-group label-for="display-record">
                                    <b-form-select class="form-select shadow-none w-fit" id="display-record" v-model="logsPerPage" :options="logsPageOptions" @change="getMaintenanceLogsData(currentModule)"></b-form-select>
                                  </b-form-group>
                                </div>
                              </div>
                              <div class="dataTables_paginate paging_simple_numbers float-end" v-if="maintenanceLogsTotal > logsPerPage">
                                <!-- pagination -->
                                <b-pagination class="pagination-rounded" v-model="logsCurrentPage" :total-rows="maintenanceLogsTotal" :per-page="logsPerPage" @input="getMaintenanceLogsData(currentModule)"></b-pagination>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- end col -->
                      </div>
                    </div>
                  </div>
                </div>
                <div class="text-end mt-3 px-1">
                  <b-button variant="light" class="w-sm" @click="closeLogsModal()">Close</b-button>
                </div>
              </form>
            </b-modal>
          </div>
          <!-- end row -->
        </div>
        <!-- end card body -->
      </div>
      <!-- end card -->
    </div>
    <!-- end col -->
  </div>
</template>




<style scoped>
/* Add these styles to your CSS */
.status-color-active {
  font-family: Roboto;
  font-size: 14px;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: left;
  color: #508F30;
}
.status-color-inactive {
  font-size: 14px;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: left;
  color: #9A211F;
}


.form-check-input:checked {
    background-color: #e83092;
    border-color: #e83092;
    transform: scale(1.2); 
}
.hr-custom {
  margin: auto;
  width: 98%;
  border: 1px solid #b6bac0;
}

</style>